// extracted by mini-css-extract-plugin
export var bandwidth = "R_c3";
export var bandwidthIcon = "R_c2";
export var button = "R_cb";
export var buttonContainer = "R_N";
export var buttons = "R_cr";
export var color = "R_bk";
export var colorContainer = "R_bj";
export var container = "R_h";
export var disclaimer = "R_c5";
export var footerSubtitle = "R_c7";
export var footerTitle = "R_c6";
export var group = "R_cW";
export var hide = "R_z";
export var icon = "R_bw";
export var info = "R_c4";
export var label = "R_cX";
export var left = "R_bS";
export var no = "R_c1";
export var number = "R_b6";
export var numbers = "R_b5";
export var numbersContainer = "R_cY";
export var right = "R_bV";
export var section = "R_b";
export var selected = "R_bg";
export var show = "R_L";
export var slideContainer = "R_bh";
export var slider = "R_bl";
export var subtitle = "R_cV";
export var text = "R_cn";
export var title = "R_f";
export var yes = "R_c0";
export var yesNoText = "R_cZ";